import { render, staticRenderFns } from "./ComparativoDeProdutos.vue?vue&type=template&id=43ecd52b"
import script from "./ComparativoDeProdutos.vue?vue&type=script&lang=js"
export * from "./ComparativoDeProdutos.vue?vue&type=script&lang=js"
import style0 from "./ComparativoDeProdutos.vue?vue&type=style&index=0&id=43ecd52b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports